import type { MentionContextType, Service } from '../graphqlEnums'
import type { MentionedChannel } from '../util/getMentionedChannelTextParts'

import { EXAMPLE_REPLY_ACCOUNT_NAME } from './exampleComments'

export type ExampleMention = {
  id: string
  service: Service
  mentionType: MentionContextType
  authorName: string
  minutesAgo: number
  text: string
}

export const EXAMPLE_MENTIONED_ACCOUNT: MentionedChannel = {
  name: 'youraccount',
  displayName: EXAMPLE_REPLY_ACCOUNT_NAME,
}

export const EXAMPLE_MENTIONS: ExampleMention[] = [
  {
    id: 'example-mention-linkedin',
    service: 'linkedin',
    mentionType: 'comment',
    authorName: 'Ana Lima',
    minutesAgo: 25,
    text: 'Totally agree. @youraccount shared a great breakdown of this last week, worth a read.',
  },
  {
    id: 'example-mention-instagram',
    service: 'instagram',
    mentionType: 'comment',
    authorName: 'jonas.creates',
    minutesAgo: 140,
    text: '@youraccount this is exactly the reminder I needed today 🙌',
  },
  {
    id: 'example-mention-youtube',
    service: 'youtube',
    mentionType: 'post',
    authorName: 'Creator Weekly',
    minutesAgo: 2880,
    text: 'Shoutout to @youraccount for the planning tips we use in this video!',
  },
]
